import axios from 'axios';
import conf from "./config";
import { message} from 'ant-design-vue';
import {getToken} from "./storage";

const openApi = ['/activity/login/back-auth', '/common/get-data', '/activity/login/get-verify-code'];

let hide = null, timer = null;
const hideLoading = function() {
  if(timer) {
    clearTimeout(timer);
    timer = null;
  } else {
    typeof hide === 'function' && hide();
    hide = null;
  }
}
axios.interceptors.request.use(config => {
  let token = getToken();
  if(openApi.indexOf(config.url) == -1 && !token) {
    location.replace('/login?r=' + location.pathname);
    return null;
  }
  if (!/^((ht|f)tps?):\/\/[\w-]+(\.[\w-]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?$/.test(config.url)) {
    let url = config.url;
    config.url = conf.host + url;
  }
  let headers = {'Content-Type': 'application/json'};
  token && (headers["Authorization"] = 'Bearer ' + token.token);
  config.headers = Object.assign(headers, config.headers);
  if(config.loadingText) {
    timer = setTimeout(() => {
      let text = config.loadingText;
      hide = message.loading(text, 0);
      timer = null;
    }, 300);
  }
  // config.withCredentials = true;
  return config;
}, err => {
  message.warning('请求超时');
  return Promise.reject(err);
});
axios.interceptors.response.use(res => {
  hideLoading();
  let status = res.status;
  if (status && /20[0-9]/.test(status + '')) {
    return res.data;
  }  else {
    return Promise.reject(res);
  }
}, err => {
  hideLoading();
  let res = err.response;
  if(res) {
    let status = res.status;
    if(status == 401) {
      location.replace('/login?r=' + location.pathname);
    } else if(status == 403) {
      message.warning('您没有权限');
    } else {
      if(Object.prototype.toString.call(res.data) === '[object Blob]') {
        const reader = new FileReader();
        reader.onload = () => {
          const data = JSON.parse(reader.result);
          if(data.message) {
            message.warning(data.message);
          } else {
            message.warning('请求错误：' + status);
          }
        };
        reader.onerror = () => {
          message.warning('请求错误：' + status);
        }
        reader.readAsText(res.data, 'utf-8');
      } else if(res.data && res.data.message) {
        message.warning(res.data.message);
      } else {
        message.warning('请求错误：' + status);
      }
    }
  } else {
    message.warning('系统繁忙');
  }
  return Promise.reject(err);
});

export default axios;

export const buddhismRequest = function (uri, data = {}) {
  let url = `/weixin/common/third-request?uri=${uri}`
  return axios({url, method: 'POST', noTempleFilter: true, data}).then(res => {
    if(res.code == 1) {
      return res.data;
    } else {
      message.warning(res.msg);
    }
  });
}
